import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/ie11"; // For IE 11 support
import "../../common/src/polyfill"

import React from 'react';
import ReactDOM from 'react-dom/client';
import ApplicationStateful from "./components/theme/ApplicationStateful";
import english from "./translations/english";
import {fetchAppConfig} from "./state/api/configAPI";
import {resolveBootstrapTimeZone, setAppTimeZone} from "common/src/utils/DateUtils";

import {initReactI18next} from "react-i18next";
import i18n from "i18next";
import {BrowserRouter} from "react-router-dom";
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

i18n.use(initReactI18next).init({
  resources: {
    en: {translation: english}
  },
  lng: "en",
}).then();

// Falls back to DateUtils' built-in default on failure, so this never blocks rendering.
fetchAppConfig()
  .then(config => setAppTimeZone(resolveBootstrapTimeZone(config)))
  .catch(() => {});

ReactDOM.createRoot(document.getElementById("app")).render(
  <BrowserRouter future={{v7_startTransition: true, v7_relativeSplatPath: true}}>
      <ApplicationStateful/>
  </BrowserRouter>
);
